const DEFAULT_DISMISS_DURATION = 500 // ms
const DEFAULT_SHOW_DURATION = 8000 // ms

const APPEND_NOTICE = 'TOASTS_APPEND_NOTICE'
const DISMISS_NOTICE = 'TOASTS_DISMISS_NOTICE'
const REMOVE_NOTICE = 'TOASTS_REMOVE_NOTICE'

function appendNotice(options) {
  return {
    type: APPEND_NOTICE,
    payload: {
      appearance: options.appearance,
      message: options.message
    }
  }
}

function removeNotice(options) {
  return {
    type: REMOVE_NOTICE,
    payload: { noticeId: options.noticeId }
  }
}

function dismissNotice(options) {
  const { dismissDuration, noticeId } = options
  if (dismissDuration === 0) {
    return removeNotice({ noticeId })
  }
  return function (dispatch) {
    dispatch({
      type: DISMISS_NOTICE,
      payload: { noticeId }
    })
    setTimeout(() => {
      dispatch(removeNotice({ noticeId }))
    }, dismissDuration || DEFAULT_DISMISS_DURATION)
  }
}

function showNotice(options) {
  const { showDuration, dismissDuration } = options
  return function (dispatch, getState) {
    dispatch(appendNotice(options))
    if (showDuration !== 0) {
      const noticeId = getState().toasts.lastId
      setTimeout(() => {
        dispatch(dismissNotice({ noticeId, dismissDuration }))
      }, showDuration || DEFAULT_SHOW_DURATION)
    }
  }
}

module.exports = {
  APPEND_NOTICE,
  DISMISS_NOTICE,
  REMOVE_NOTICE,
  dismissNotice,
  removeNotice,
  showNotice
}
